(() => {
  const script = document.currentScript;
  if (!(script instanceof HTMLScriptElement)) return;

  const articleHandle = script.dataset.articleHandle || '';
  const allowedHosts = new Set(
    [window.location.hostname, script.dataset.shopDomain, script.dataset.permanentDomain].filter(Boolean)
  );
  const linkSelector = [
    '[class^="ai-blog-article-body-"] a[href]',
    '[class*=" ai-blog-article-body-"] a[href]',
    '.blog-post-content a[href]',
    '[data-serenett-products-wrapper] a[href]',
  ].join(',');

  const applyTracking = (scope = document) => {
    scope.querySelectorAll(linkSelector).forEach((link) => {
      if (!(link instanceof HTMLAnchorElement)) return;

      let url;
      try {
        url = new URL(link.href, window.location.href);
      } catch {
        return;
      }

      if (!allowedHosts.has(url.hostname)) return;

      const match = url.pathname.match(/\/(products|collections)\/([^/]+)\/?$/);
      if (!match) return;

      const [, resourceType, encodedHandle] = match;
      const trackingType = resourceType === 'products' ? 'blog-product-link' : 'blog-collection-link';

      if (link.dataset.gtm && link.dataset.gtm !== 'cta' && link.dataset.gtm !== trackingType) return;

      let handle = encodedHandle;
      try {
        handle = decodeURIComponent(encodedHandle);
      } catch {
        // Keep the URL-safe handle when decoding malformed input is not possible.
      }

      link.dataset.gtm = trackingType;
      link.dataset.gtmName = handle;
      if (articleHandle) link.dataset.gtmContent = articleHandle;
      link.dataset.gtmUrl = `${url.pathname}${url.search}`;
    });
  };

  applyTracking();
  document.addEventListener('shopify:section:load', (event) => applyTracking(event.target));
})();
